export default "__VITE_ASSET__CyWirXlD__"